import { render, staticRenderFns } from "./naturalLanguageProcessingComponent.vue?vue&type=template&id=6ac0a21e"
import script from "./naturalLanguageProcessingComponent.vue?vue&type=script&lang=js"
export * from "./naturalLanguageProcessingComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports